import React, { createContext, useContext } from "react";
import { UseOrgSharing } from "./useOrgSharing";

// Shares one useOrgSharing instance across the Data Sharing screen so the connected-orgs list
// ("Who can see my data"), the Organizations section, and the invite popup's org list
// all read/write the same state. The host (MyFollowers) owns the instance and passes it as
// `value` — so the host can use it directly too. React context flows through IonModal portals, so
// the popup (a modal child) shares it.
const OrgSharingContext = createContext<UseOrgSharing | null>(null);

export const OrgSharingProvider: React.FC<{
  value: UseOrgSharing;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <OrgSharingContext.Provider value={value}>
    {children}
  </OrgSharingContext.Provider>
);

export const useOrgSharingContext = (): UseOrgSharing => {
  const ctx = useContext(OrgSharingContext);
  if (!ctx) {
    throw new Error(
      "useOrgSharingContext must be used within an OrgSharingProvider",
    );
  }
  return ctx;
};
